import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import imagingServicesdata from "../../data/imagingServicesdata";
import GetINTouch from "../Contactus/GetINTouch";
export default function ImagingService() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    }); // Scroll to the top when the component mounts
  }, []);
  return (
    <div>
      <div className="pt-16 sm:pt-20 md:pt-24 lg:pt-[12.0625rem] overflow-hidden">
        <div className="px-4 py-8 sm:px-6 sm:py-10 md:px-8 md:py-12 lg:px-10 lg:py-16">
          {/* Main Heading */}
          <div className="relative mb-10 lg:mb-60">
            <div className="flex justify-center pt-28 md:pt-12 lg:pt-0">
              <div>
                <h1 className="font-Antique text-white text-[3rem] leading-[60px]  md:text-[6rem] lg:text-[7.5rem] lg:leading-[120px] xl:text-[9.25rem]  md:leading-snug xl:leading-[140px] 2xl:leading-[144px] tracking-[-.03em] lowercase">
                  <span>Imaging</span> <br />
                  <span className="xl:ml-[25.5rem] lg:ml-[18rem] md:ml-[10rem] ml-[3rem]">
                    Services
                  </span>
                </h1>
              </div>
            </div>
          </div>
          {/* Split Layout in groups of two */}
          {Array.from(
            { length: Math.ceil(imagingServicesdata.length / 2) },
            (_, groupIndex) => (
              <div
                key={groupIndex}
                className={`grid grid-cols-1 lg:grid-cols-2 gap-16 xl:w-4/5 w-11/12 mx-auto ${
                  groupIndex > 0 ? "xl:mt-40 lg:mt-28 mt-20" : ""
                }`}
              >
                {imagingServicesdata
                  .slice(groupIndex * 2, groupIndex * 2 + 2)
                  .map((service, idx) => (
                    <Link
                      key={idx}
                      to={`/services/${service.slug}`}
                      className="relative" data-aos="fade-up" data-aos-delay={`${idx + 1 * 50}`}
                    >
                      <div
                        className={`relative xl:h-[500px] lg:h-[400px] overflow-hidden rounded-[2rem] ${
                          service.extraTopMargin ? "mt-10" : ""
                        }`}
                      >
                        <img
                          src={service.image}
                          alt={service.alt}
                          className="w-full h-full object-cover transition-transform duration-1000 ease-in-out hover:scale-110 cursor-pointer"
                        />
                      </div>
                      <div>
                        <p className="text-white text-[1.75rem] leading-[1.14286] md:tracking-[-.06em] mt-4 md:w-[21.875rem] font-Matter">
                          {service.subTitle}
                        </p>
                        <h3 className="text-white text-[28px] md:text-[2.25rem] md:leading-[1.125] md:tracking-[-.06em] font-bold capitalize font-Antique mt-4">
                          {service.title}
                        </h3>
                      </div>
                    </Link>
                  ))}
              </div>
            )
          )}
        </div>
      </div>
      <GetINTouch />
    </div>
  );
}
